// @core/api/endpoints/license/suspend_license.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  LicenseResponse,
  SuspendLicenseRequest,
} from '../../../types/license';

const BASE_PATH = '/license';

/**
 * Suspend license
 * Temporarily suspends a license. Can be resumed later with ResumeLicense. Master-only operation.
 */
export async function SuspendLicense(
  license_id: string,
  data: SuspendLicenseRequest,
  options?: RequestOptions
): Promise<LicenseResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/licenses/:license_id/suspend`;
  requestPath = requestPath.replace(':license_id', encodeURIComponent(license_id));
  const requestOptions = options;
  return client.post<LicenseResponse>(requestPath, data, requestOptions);
}
